<!--
 * @Description: 导入出文件弹框
 * @Autor: txp
 * @Date: 2021-04-19 16:49:05
-->
<template>
    <div class="addexportfile">
        <el-dialog
        title="导出明细"
        :visible.sync="openCardDialog"
        :before-close="handleClose"
        :lock-scroll="false"
        :destroy-on-close="true"
         width="50%">
        <div v-html="exportMessage">
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="Cancel">取 消</el-button>
            <el-button size="small" type="primary"  @click="Save">确 定</el-button>
        </span>
    </el-dialog>
    </div>
</template>
<script>
import {RepeatedWriteExport} from "@/api/api";
import ReconnectingWebSocket from 'reconnecting-websocket';
import {Storage} from "@/utils/storage";
import { getUuid } from '@/utils/index';
export default{
    name:"addexportfile",
    data(){
        return{
            sid:"",
            exportMessage:'',
        }
    },
    props: {
        visible: { //是否显示
            type: Boolean,
            default: false
        },
        dateTimes:{ //开始时间和结束时间
            type:Array,
            default:()=>{}
        },
        functionCode:{
            type:String,
            default:''
        },
        parentCode:{
            type:String,
            default:''
        },
        requestUrl:{
            type:String,
            default:''
        }
    },
    computed: {
        openCardDialog: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
            }
        }
    },
    watch:{ 
        sid(val){
            this.createWebsocket()
        }
    },
    created(){
        this.Addexport()
    },
    methods:{
    /**
     * @description:  弹框的关闭
     * @param {*}
     * @return {*}
     * @author: txp
     */    
    // 取消
    Cancel () {
        this.$emit('resetPopupData')
    },
    // 确定
    Save () {
        this.$emit('submitPopupData')
    },
    // 关闭
    handleClose () {
        this.$emit('handleClose')
    },
    /**
     * @description: 导出导出
     * @param {*} sid 通过调用getUuid方法，获取到sid
     * @param {*} requestUrl 请求当前数据的地址,根据当前请求的地址进行传参
     * @param {*} customerCode 用户编码
     * @param {*} parentCode 订单编号
     * @return {*} 
     * @author: txp
     */
    Addexport(){
       this.sid = getUuid(32,16);
       let params = {
        beginDate: this.dateTimes ? this.dateTimes[0] : "",
        endDate: this.dateTimes ? this.dateTimes[1] : "",
        customerCode: Storage.l.get('customerCode'),
        functionCode: this.functionCode,
        parentCode: this.parentCode,
        requestUrl: this.requestUrl,
        sid: this.sid,
        }
      RepeatedWriteExport(params).then(res=>{
      }).catch(error=>{
          this.$message.error(error)
      })
      // 连接websocket
      this.createWebsocket();
    },
    //  创建 websocket 链接
    createWebsocket() {
      if (typeof (WebSocket) === 'undefined') {
        this.$message.error('您的浏览器不支持socket');
      } else {
        console.log('浏览器支持socket');
      }
      const token = Storage.l.get('TokenKey')
      let httpStr = '';
      if (window.location.protocol === 'http:') {
        httpStr = 'ws';
      } else {
        httpStr = 'wss';
      }
      let tokens = Storage.l.get("TokenKey")
        // 链接websocket
      this.websocket =  new ReconnectingWebSocket(
        `${httpStr}://${window.location.host}/excel/websocket/user?sid=${this.sid}&&token=${tokens}`,
      );
      // 连接发生错误的回调方法
      this.websocket.onerror = this.websocketOnerror;
      // 连接成功建立的回调方法
      this.websocket.onopen = this.websocketOnopen;
      // 接收到消息的回调方法
      this.websocket.onmessage = (event) => {
        this.websocketOnmessage(event, this.sid);
      };
      // 连接关闭的回调方法
      this.websocket.onclose = this.websocketOnclose;
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      this.websocket.onbeforeunload = this.websocketOnbeforeunload;
        },
        // 连接发生错误的回调方法
        websocketOnerror() {
        console.log('连接发生错误的回调方法');
        },
        // 连接成功建立的回调方法
        websocketOnopen() {
        console.log('连接成功建立的回调方法');
        },
        // 接收到消息的回调方法
        websocketOnmessage(event) {
        const data = JSON.parse(event.data);
        this.exportMessage += `${data.message}<br/>`;
        },
        // 连接关闭的回调方法
        websocketOnclose() {
        console.log('连接关闭的回调方法');
        },
        // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常
        websocketOnbeforeunload() {
        this.closeWebSocket();
        console.log(
            '监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常',
        );
        },
        // 关闭WebSocket连接
        closeWebSocket() {
        console.log('关闭');
        this.websocket.close();
        },
    },
    destroyed(){
        this.closeWebSocket();
    }
}
</script>
